import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReactiveFormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../../../../common/decorators';
import { ActionButtonComponent, ButtonAction } from '../../../action-button';
import { ProfileReportItem } from '../../../../store/models';
import { IconNames, MAX_FIELD_WARNING_COUNT_EXPORT } from '../../../../common/constants';
import { DirectivesModule } from '../../../../common/directives/directives.module';
import { SvgIconComponent } from '../../../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-mat-chips-report-columns-dialog',
  templateUrl: './mat-chips-report-columns-dialog.component.html',
  styleUrls: ['./mat-chips-report-columns-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    TranslateModule,
    DirectivesModule,
    SvgIconComponent,
    ActionButtonComponent,
  ],
})
@AutoUnsubscribe
export class MatChipsReportColumnsDialogComponent implements OnInit {
  subscriptions: Subscription[] = [];
  buttonAction = ButtonAction;
  formArray: UntypedFormArray;
  selectedFieldsCount: number;
  iconNameList = IconNames;
  readonly maxFieldsWarningCount = MAX_FIELD_WARNING_COUNT_EXPORT;

  constructor(
    public dialogRef: MatDialogRef<MatChipsReportColumnsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      filterName: string;
      label: string;
      filtersFormControlOrGroup: UntypedFormGroup | UntypedFormControl;
      reportItemList: ProfileReportItem[];
      maxFieldsCount: number;
    },
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit(): void {
    this.initCodeListForm(this.data.reportItemList);
    this.subscriptions.push(
      this.formArray.valueChanges.subscribe(() => {
        this.selectedFieldsCount = this.formArray.value.filter((item: ProfileReportItem) => item.isSelected).length;
      }),
    );
  }

  apply(): void {
    const selectedItems = this.formArray.value.filter((item: ProfileReportItem) => item.isSelected);

    this.dialogRef.close({ selectedItems });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private initCodeListForm(items: ProfileReportItem[]): void {
    this.formArray = this.fb.array([]);
    items.forEach((item: ProfileReportItem) => {
      this.formArray.push(
        new UntypedFormGroup({
          isSelected: new UntypedFormControl(
            Boolean(
              this.data?.filtersFormControlOrGroup.value.some(
                (controlValueItem: ProfileReportItem) => controlValueItem.value === item.value,
              ),
            ),
          ),
          value: new UntypedFormControl(item.value),
          title: new UntypedFormControl(item.title),
          required: new UntypedFormControl(item.required),
        }),
      );
    });
  }
}
